module.exports = __webpack_public_path__ + "static/media/home_13.881ae277.jpg";